import React, { useState } from 'react';
import SelectItemsView from './SelectItemsView.js';
import ComparingItemsView from './ComparingItemsView.js';

export default function SelectedProdBar(props) {
	const [ribbonCompareState, setRibbonCompareState] = useState(true);

	const hasItemsSelected = checkForItemsSelected();
	if (!hasItemsSelected && !ribbonCompareState) {
		setRibbonCompareState(true);
	}

	function handleCompareAction() {
		setRibbonCompareState(!ribbonCompareState);
	}

	function checkForItemsSelected() {
		let itemsSelected = props.compareItems.filter((item) => item.isSelected == true);
		if (itemsSelected && itemsSelected.length > 0) {
			return true;
		} else {
			return false;
		}
	}

	// render
	if (ribbonCompareState) {
		return (
			<SelectItemsView
				comparisonTableId={props.comparisonTableId}
				compareItems={props.compareItems}
				handleComparisonSelection={props.handleComparisonSelection}
				handleCancelSelectProd={props.handleCancelSelectProd}
				handleCompareAction={handleCompareAction}
				checkForItemsSelected={hasItemsSelected}
			/>
		);
	} else {
		return (
			<ComparingItemsView
				comparisonTableId={props.comparisonTableId}
				compareItems={props.compareItems}
				handleComparisonSelection={props.handleComparisonSelection}
				handleCancelSelectProd={props.handleCancelSelectProd}
				tabularData={props.tabularData}
				productPath={props.productPath}
				handleCompareAction={handleCompareAction}
			/>
		);
	}
}
